(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8623],{

/***/ 45348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function Header(params) {
  var title = params.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "bg-[#231C5E] text-white px-12 pb-6 space-y-2",
    style: {
      backgroundColor: "#22242C"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
      children: title
    })
  });
}

/***/ }),

/***/ 24867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/landing/Container.jsx + 1 modules
var Container = __webpack_require__(94964);
// EXTERNAL MODULE: ./components/aboutus/Header.jsx
var Header = __webpack_require__(45348);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/aboutus/members.js
var Members = [{
  id: 1,
  name: "Alex Christian",
  position: "CEO",
  positionFull: "Co-Founder and CEO",
  text: "With nearly a decade of experience launching and operating highly regulated B2B cross border financial and crypto services at Airwallex, Western Union Business Solutions, Metal Pay and eBay among others, Alex believes that the legacy financial industry’s overgrowth in cost, size, and risk (see bailouts) must be countered to drive equitable opportunities. Thankfully, decentralized financial services are evolutionary game changers and that problem solving infrastructure, products and applications simply need to be built. He is committed to do just that. He holds an MBA from Duke University.",
  imgSrc: "/Alex.png",
  linkedin: "https://www.linkedin.com/in/alexjchristian"
}, {
  id: 2,
  name: "Shivam Chaturvedi",
  position: "CTO",
  positionFull: "Co-Founder and CTO",
  text: "Shivam holds a Bachelor’s degree in Computer Science and is on a mission to break all the barriers for non-crypto natives towards the path of crypto adoption with Data Mynt. Since he was 13 years young he has worked hard to achieve a single goal - ‘build great technology and lead innovation with global reach.’ He’s led innovation and developed technology for several leading startups in the blockchain space. His open source proposal was accepted by Web3 Foundation.",
  imgSrc: "/Shivam.png",
  linkedin: "https://www.linkedin.com/in/shivam-cto"
}, {
  id: 3,
  name: "Adebola Olatunbosun",
  position: "CBO",
  positionFull: "CBO",
  text: "Adebola is a seasoned finance and investor relations professional with diversified experience across finance, energy and fintech businesses. He has consistently produced outstanding outcomes spanning his career while executing strategic initiatives within the fintech ecosystem at Fair Money, Zuvy and Forte Oil.",
  imgSrc: "/Adebola.png",
  linkedin: "https://www.linkedin.com/in/olatunbosunadebola/"
}, {
  id: 4,
  name: "Charles Philip Ukaegbu",
  position: "Product Manager",
  text: "Charles have over 6 years experience building across various product verticals: E-commerce, Gaming, Cross Border Payments, On/Off ramp solutions & Integrations. He is passionate about leveraging blockchain to facilitate payments, especially in developing countries and have built products that have simplified payments across borders. He is based out of Lagos, Nigeria and an avid football lover.",
  imgSrc: "/charlesPhoto.png",
  linkedin: "https://www.linkedin.com/in/charles-philip-ukaegbu-13200467"
}, {
  id: 5,
  name: "Vinod Morkile",
  position: "Engineering",
  text: "Vinod holds a Bachelor’s degree in Computer Science with 9+ years experience across software architecture and development. He started working in the Cryptocurrency and Blockchain world in early 2017. He has worked on ICO projects, Cryptocurrency wallet projects, and Cryptocurrency exchange projects. While working on a cryptocurrency exchange, he started learning about DeFi and its benefits. Vinod believes that Defi is the viable replacement for legacy financial services.",
  imgSrc: "/Vinod.png",
  linkedin: "https://www.linkedin.com/in/vm18264391/"
}, {
  id: 6,
  name: "Mary Ogola",
  position: "Operations",
  text: "Mary is based in Nairobi, Kenya. An expert in driving business development and growth. She holds a Bachelors degree in Commerce Finance option and her past experiences includes Sales Development Representative at Co-operative Bank of Kenya, Business Development at ABSA Bank of Kenya and various sales & marketing roles at  Kava Africa & Spiral Groups. She loves volunteering and arts.",
  imgSrc: "/maryNew.jpg",
  linkedin: "https://www.linkedin.com/in/mogola"
}, {
  id: 7,
  name: "Michael Kirore ",
  position: "Business Development",
  text: "Michael is a dynamic Business Development Executive with over 9 years of proven experience enhancing organizational profitability and performance through high-impact sales. Notable success; building rapport, analyzing customer needs, and overcoming challenging obstacles.",
  imgSrc: "/michealNew.jpg",
  linkedin: "https://www.linkedin.com/in/michael-kirore-8bb4796b"
}, {
  id: 8,
  name: "Franklin Okeugo",
  position: "PR & Social Media",
  text: "Franklin is Lagos-based Marketing and PR professional with more than 6 years experience working across tech, e-commerce, security, fintech, energy, N.G.O, sports, manufacturing, real estate and agency. He specializes in creating exceptional brand experiences around media, content and design to maximize traction across digital and traditional channels to engineer growth. He loves music, networking, traveling.",
  imgSrc: "/franklin.png",
  linkedin: "https://www.linkedin.com/in/franklin-okeugo-564a3a46/"
}, {
  id: 9,
  name: "Samuel Olaide",
  position: "Community Manager",
  text: "Samuel Olaide is our Nigerian digital nomad Community & Marketing Manager. Samuel has 4+ years of experience developing and managing thriving web3 communities at scale, which cascades into web3 product cults, ultras, investors, and champions. He loves traveling the continent of Europe as a digital nomad when not building digital communities.",
  imgSrc: "/samuel.png",
  linkedin: "https://www.linkedin.com/in/samuel-olaide-607412258/"
}, {
  id: 10,
  name: "Chioma Dimgba",
  position: "Business Development",
  text: "Chioma Dimgba is our Nigeria-based Partnership Manager. She enjoys music, singing, and football. Chioma has 10 years of B2B sales experience at D.D Fassion Hub. She’s also the Founder of Market Field, an ecommerce business for wholesale and retail products.",
  imgSrc: "/chioma.png",
  linkedin: "https://www.linkedin.com/in/chioma-dimgba-05bab1257"
}];
/* harmony default export */ var members = (Members);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/aboutus/MemberList.jsx







function MemberList() {
  var _useState = (0,react.useState)(-1),
      selectedMemberId = _useState[0],
      setSelectedMember = _useState[1];

  var MemberCard = function MemberCard(item) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      type: "button",
      onClick: function onClick() {
        return setSelectedMember(item.id);
      },
      className: "relative p-4 rounded-lg hover:shadow-lg block",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        layout: "responsive",
        width: 100,
        height: 100,
        alt: "Data Mynt team member",
        className: "rounded-md",
        src: item.imgSrc
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center justify-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "mt-3",
          style: {
            fontSize: "0.875rem",
            textTransform: "uppercase",
            color: "#1A1A1A",
            fontFamily: "Inter",
            fontWeight: "700"
          },
          children: item.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: {
            fontSize: "0.875rem",
            textTransform: "uppercase",
            color: "#3D8ECD",
            fontFamily: "Inter",
            fontWeight: "600"
          },
          children: item.position
        })]
      })]
    }, item.id);
  };

  var MemberModal = function MemberModal(_ref) {
    var member = _ref.member;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "fixed z-10 inset-0 pt-24 bg-black bg-opacity-60 overflow-y-auto flex items-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex pt-12 px-4 pb-20 text-center sm:block sm:p-0 w-full justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "inline-block align-bottom bg-white rounded-lg w-full xs:max-w-md sm:max-w-xl md:max-w-2xl lg:max-w-5xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 overflow-auto",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              className: "absolute top-2 right-2 text-[#231C5E]",
              onClick: function onClick() {
                return setSelectedMember(-1);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                alt: "Close",
                src: "/closeIcon.svg",
                width: 24,
                height: 24
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col sm:flex-row items-center w-full justify-between pt-4",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "bg-primary w-full p-2 rounded-lg bg-gradient-to-b from-primary to-purple-primary mb-6 w-10/12 xs:w-6/12 ",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  layout: "responsive",
                  width: "100%",
                  height: "100%",
                  src: member.imgSrc
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "w-full p-4",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex flex-row space-x-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                    className: "text-base sm:text-2xl",
                    children: member.name.toUpperCase()
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: member.linkedin,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      className: "w-6 h-6 lg:h-8 lg:w-8 flex items-center justify-center text-white bg-primary rounded-full p-2",
                      target: "_blank",
                      rel: "noreferrer",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {})
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
                  className: "text-primary text-sm sm:text-xl lg:pt-2",
                  children: member.positionFull ? member.positionFull : member.position
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mt-2 text-xs md:text-sm lg:text-base lg:pt-4 lg:leading-7",
                  children: member.text
                })]
              })]
            })]
          })
        })
      })
    });
  };

  var selectedMember = members.find(function (m) {
    return m.id === selectedMemberId;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "grid p-4 gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-b border-gray-10",
    style: {
      flexWrap: "wrap"
    },
    children: [selectedMember && /*#__PURE__*/(0,jsx_runtime.jsx)(MemberModal, {
      member: selectedMember
    }), members.map(MemberCard)]
  });
}
// EXTERNAL MODULE: ./data/seo.json
var seo = __webpack_require__(35546);
;// CONCATENATED MODULE: ./pages/aboutus.jsx









function About() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: seo.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "title",
        content: seo.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: seo.description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "og:title",
        content: seo.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "og:description",
        content: seo.description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: "/favicon/favicon-32x32.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: "/favicon/favicon-16x16.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "manifest",
        href: "/favicon/site.webmanifest"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "mask-icon",
        href: "/favicon/safari-pinned-tab.svg",
        color: "#5bbad5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "msapplication-TileColor",
        content: "#2b5797"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "theme-color",
        content: "#ffffff"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: "/favicon/apple-icon-57x57.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "60x60",
        href: "/favicon/apple-icon-60x60.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: "/favicon/apple-icon-72x72.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: "/favicon/apple-icon-76x76.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: "/favicon/apple-icon-114x114.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: "/favicon/apple-icon-120x120.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: "/favicon/apple-icon-144x144.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: "/favicon/apple-icon-152x152.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: "/favicon/apple-icon-180x180.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "192x192",
        href: "/favicon/android-icon-192x192.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: "/favicon/favicon-32x32.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "96x96",
        href: "/favicon/favicon-96x96.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: "/favicon/favicon-16x16.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "manifest",
        href: "/favicon/manifest.json"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "msapplication-TileColor",
        content: "#ffffff"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "msapplication-TileImage",
        content: "/ms-icon-144x144.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "theme-color",
        content: "#ffffff"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        background: "white"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
          title: "Our Team"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MemberList, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        src: "https://www.googleoptimize.com/optimize.js?id=OPT-WWVFB9W"
      })]
    })]
  });
}

/***/ }),

/***/ 31514:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aboutus",
      function () {
        return __webpack_require__(24867);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ }),

/***/ 35546:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"The Future of Business Banking & Payments","description":"On-Chain Financial Infrastructure For Today’s Businesses"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,5675,6770,9530,4964,9774,2888,179], function() { return __webpack_exec__(31514); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);